import React from "react";

const CustomPagination = ({
  currentPage,
  totalPages,
  onChangePage
}) => {
  const getPages = () => {
    const pages = [];
    const delta = 1;
    const rangeStart = Math.max(2, currentPage - delta);
    const rangeEnd = Math.min(totalPages - 1, currentPage + delta);

    pages.push(1);
    if (rangeStart > 2) pages.push("...");
    for (let i = rangeStart; i <= rangeEnd; i++) pages.push(i);
    if (rangeEnd < totalPages - 1) pages.push("...");
    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  return (
    <div style={styles.container}>
      <button
        style={styles.navBtn}
        disabled={currentPage === 1}
        onClick={() => onChangePage(currentPage - 1)}
      >
        Prev
      </button>

      {getPages().map((page, index) =>
        page === "..." ? (
          <span key={index} style={styles.dots}>...</span>
        ) : (
          <button
            key={page}
            onClick={() => onChangePage(page)}
            style={{
              ...styles.pageBtn,
              ...(currentPage === page ? styles.active : {})
            }}
          >
            {page}
          </button>
        )
      )}

      <button
        style={styles.navBtn}
        disabled={currentPage === totalPages}
        onClick={() => onChangePage(currentPage + 1)}
      >
        Next
      </button>
    </div>
  );
};

export default CustomPagination;

const styles = {
  container: { display: "flex", justifyContent: "center", gap: "8px", padding: "15px", borderTop: "1px solid #eee" },
  pageBtn: { padding: "6px 12px", borderRadius: "8px", border: "1px solid #ddd", background: "#fff", cursor: "pointer", fontWeight: 500 },
  active: { background: "#0d6efd", color: "#fff", border: "none" },
  navBtn: { padding: "6px 12px", borderRadius: "8px", border: "1px solid #ddd", background: "#f8f9fa", cursor: "pointer" },
  dots: { padding: "0 6px", fontWeight: "bold", color: "#999" }
};
